import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getStatusList = store => store[NAME].statusList;
export const getChangePointsList = store => store[NAME].changePointsList;
export const getPriceAwardingList = store => store[NAME].priceAwardingList;
export const getDiffusionList = store => store[NAME].diffusionList;
export const getAnnotationList = store => store[NAME].annotationList;
export const getCollaboratorsInPlans = store => store[NAME].collaboratorsInPlans;